import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { ChipsModule } from 'primeng/chips';
import { DropdownModule } from 'primeng/dropdown';
import { AgentChannelsComponent } from './components/agent-channels/agent-channels.component';
import { AgentPlaybooksComponent } from './components/agent-playbooks/agent-playbooks.component';
import { AgentTestChatComponent } from './components/agent-test-chat/agent-test-chat.component';
import { AgentToolsComponent } from './components/agent-tools/agent-tools.component';
import { AgentTriggersComponent } from './components/agent-triggers/agent-triggers.component';
import { AGENT_PERMISSIONS as P } from './models/ai-agents.models';
import { CapabilityModelsPageComponent } from './pages/capability-models-page/capability-models-page.component';
import { AgentEditorPageComponent } from './pages/agent-editor-page/agent-editor-page.component';
import { AgentsListPageComponent } from './pages/agents-list-page/agents-list-page.component';
import { ConversationDetailPageComponent } from './pages/conversation-detail-page/conversation-detail-page.component';
import { ConversationsPageComponent } from './pages/conversations-page/conversations-page.component';
import { ModelsPageComponent } from './pages/models-page/models-page.component';
import { ProjectPlansPageComponent } from './pages/project-plans-page/project-plans-page.component';
import { ProvidersPageComponent } from './pages/providers-page/providers-page.component';
import { AgentPermissionGuard } from './services/agent-permissions.service';

/** Admin pages of the AI Agents Service (system scope). Each route needs its system.agent.* permission. */
export const AI_AGENTS_ROUTES: Routes = [
  { path: 'ai-agents', pathMatch: 'full', redirectTo: 'ai-agents/agents' },
  {
    path: 'ai-agents/providers',
    component: ProvidersPageComponent,
    canActivate: [AgentPermissionGuard],
    data: { permission: P.providerList },
  },
  {
    path: 'ai-agents/models',
    component: ModelsPageComponent,
    canActivate: [AgentPermissionGuard],
    data: { permission: P.modelList },
  },
  {
    path: 'ai-agents/capability-models',
    component: CapabilityModelsPageComponent,
    canActivate: [AgentPermissionGuard],
    data: { permission: P.capabilityList },
  },
  {
    path: 'ai-agents/agents',
    component: AgentsListPageComponent,
    canActivate: [AgentPermissionGuard],
    data: { permission: P.agentList },
  },
  {
    path: 'ai-agents/agents/new',
    component: AgentEditorPageComponent,
    canActivate: [AgentPermissionGuard],
    data: { permission: P.agentCreate },
  },
  {
    path: 'ai-agents/agents/:id',
    component: AgentEditorPageComponent,
    canActivate: [AgentPermissionGuard],
    data: { permission: P.agentGet },
  },
  {
    path: 'ai-agents/project-plans',
    component: ProjectPlansPageComponent,
    canActivate: [AgentPermissionGuard],
    data: { permission: P.planList },
  },
  {
    path: 'ai-agents/conversations',
    component: ConversationsPageComponent,
    canActivate: [AgentPermissionGuard],
    data: { permission: P.conversationList },
  },
  {
    path: 'ai-agents/conversations/:id',
    component: ConversationDetailPageComponent,
    canActivate: [AgentPermissionGuard],
    data: { permission: P.conversationGet },
  },
  // Old agent-service links land on the new pages.
  { path: 'agents', redirectTo: 'ai-agents/agents' },
  { path: 'agent-chat', redirectTo: 'ai-agents/agents' },
  { path: 'agent-conversations', redirectTo: 'ai-agents/conversations' },
];

@NgModule({
  declarations: [
    ProvidersPageComponent,
    ModelsPageComponent,
    CapabilityModelsPageComponent,
    AgentsListPageComponent,
    AgentEditorPageComponent,
    AgentChannelsComponent,
    AgentPlaybooksComponent,
    AgentToolsComponent,
    AgentTriggersComponent,
    AgentTestChatComponent,
    ConversationsPageComponent,
    ConversationDetailPageComponent,
    ProjectPlansPageComponent,
  ],
  imports: [CommonModule, FormsModule, RouterModule.forChild(AI_AGENTS_ROUTES), DropdownModule, ChipsModule],
})
export class AiAgentsModule {}
